/**
 * Polyfill for navigator.share
 */
navigator.share = (function() {

    const nativeShare = navigator.share;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    const icons = {
        copy: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard-check" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"/><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/></svg>`,
        print: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16"><path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"/><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"/></svg>`,
        email: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16"><path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/></svg>`,
        facebook: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16"><path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/></svg>`,
        messenger: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-messenger" viewBox="0 0 16 16"><path d="M0 7.76C0 3.301 3.493 0 8 0s8 3.301 8 7.76-3.493 7.76-8 7.76c-.81 0-1.586-.107-2.316-.307a.64.64 0 0 0-.427.03l-1.588.702a.64.64 0 0 1-.898-.566l-.044-1.423a.64.64 0 0 0-.215-.456C.956 12.108 0 10.092 0 7.76m5.546-1.459-2.35 3.728c-.225.358.214.761.551.506l2.525-1.916a.48.48 0 0 1 .578-.002l1.869 1.402a1.2 1.2 0 0 0 1.735-.32l2.35-3.728c.226-.358-.214-.761-.551-.506L9.728 7.381a.48.48 0 0 1-.578.002L7.281 5.98a1.2 1.2 0 0 0-1.735.32z"/></svg>`,
        twitter: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16"><path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/></svg>`,
        whatsapp: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16"><path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/></svg>`,
        telegram: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/></svg>`,
        skype: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skype" viewBox="0 0 16 16"><path d="M4.671 0c.88 0 1.733.247 2.468.702a7.42 7.42 0 0 1 6.02 2.118 7.37 7.37 0 0 1 2.167 5.215q0 .517-.072 1.026a4.66 4.66 0 0 1 .6 2.281 4.64 4.64 0 0 1-1.37 3.294A4.67 4.67 0 0 1 11.18 16c-.84 0-1.658-.226-2.37-.644a7.42 7.42 0 0 1-6.114-2.107A7.37 7.37 0 0 1 .529 8.035q0-.545.08-1.081a4.644 4.644 0 0 1 .76-5.59A4.68 4.68 0 0 1 4.67 0zm.447 7.01c.18.309.43.572.729.769a7 7 0 0 0 1.257.653q.737.308 1.145.523c.229.112.437.264.615.448.135.142.21.331.21.528a.87.87 0 0 1-.335.723c-.291.196-.64.289-.99.264a2.6 2.6 0 0 1-1.048-.206 11 11 0 0 1-.532-.253 1.3 1.3 0 0 0-.587-.15.72.72 0 0 0-.501.176.63.63 0 0 0-.195.491.8.8 0 0 0 .148.482 1.2 1.2 0 0 0 .456.354 5.1 5.1 0 0 0 2.212.419 4.6 4.6 0 0 0 1.624-.265 2.3 2.3 0 0 0 1.08-.801c.267-.39.402-.855.386-1.327a2.1 2.1 0 0 0-.279-1.101 2.5 2.5 0 0 0-.772-.792A7 7 0 0 0 8.486 7.3a1 1 0 0 0-.145-.058 18 18 0 0 1-1.013-.447 1.8 1.8 0 0 1-.54-.387.73.73 0 0 1-.2-.508.8.8 0 0 1 .385-.723 1.76 1.76 0 0 1 .968-.247c.26-.003.52.03.772.096q.412.119.802.293c.105.049.22.075.336.076a.6.6 0 0 0 .453-.19.7.7 0 0 0 .18-.496.72.72 0 0 0-.17-.476 1.4 1.4 0 0 0-.556-.354 3.7 3.7 0 0 0-.708-.183 6 6 0 0 0-1.022-.078 4.5 4.5 0 0 0-1.536.258 2.7 2.7 0 0 0-1.174.784 1.9 1.9 0 0 0-.45 1.287c-.01.37.076.736.25 1.063"/></svg>`,
        linkedin: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/></svg>`,
    }

    const urls = {
        copy: '',
        print: '',
        email: 'mailto:',
        facebook: 'https://www.facebook.com/sharer/sharer.php',
        messenger: 'https://www.facebook.com/dialog/send',
        twitter: 'https://twitter.com/intent/tweet',
        whatsapp: 'https://wa.me',
        telegram: 'https://t.me/share/url',
        skype: 'https://web.skype.com/share',
        linkedin: 'https://www.linkedin.com/shareArticle',
    }

    const labels = {
        copy: 'Copia',
        print: 'Stampa',
        email: 'Email',
        facebook: 'Facebook',
        messenger: 'Messenger',
        twitter: 'Twitter',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        skype: 'Skype',
        linkedin: 'LinkedIn',
    }
    
    function buildItem(type, data) {
        const details = getTypeDetails(type, data);

        const item = document.createElement('div');
        item.className = 'share-item';
        item.dataset.type = type;
        item.dataset.url = details.url;
        item.role = 'button';
        
        item.innerHTML = `
            <span class="share-icon">${details.icon}</span>
            <span class="share-icon-text">${labels[type]}</span>
        `;
        return item;
    }

    function getTypeDetails(type, data) {
        const url = urlWithQueryStringByType(type, data);
        return {url, icon: icons[type], type};
    }

    function urlWithQueryStringByType(type, data) {
        switch (type) {
            case 'copy':
                return data.url;
            case 'email':
                return urls.email + '?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(data.text + ' ' + data.url);
            case 'facebook':
                return urls.facebook + '?u=' + encodeURIComponent(data.url);
            case 'messenger':
                return urls.messenger + '?' +
                'app_id=' + data.facebookID +
                '&display=popup' +
                '&href=' + encodeURIComponent(data.url) +
                '&link=' + encodeURIComponent(data.url) +
                '&redirect_uri=' + encodeURIComponent(data.url) +
                '&quote=' + encodeURIComponent(data.text);
            case 'twitter':
                return urls.twitter + '?url=' + encodeURIComponent(data.url) + '&text=' + encodeURIComponent(data.text);
            case 'whatsapp':
                return urls.whatsapp + '?text=' + encodeURIComponent(data.text + ' ' + data.url);
            case 'telegram':
                return urls.telegram + '?url=' + encodeURIComponent(data.url) + '&text=' + encodeURIComponent(data.text);
            case 'skype':
                return urls.skype + '?url=' + encodeURIComponent(data.url);
            case 'linkedin':
                return urls.linkedin + '?url=' + encodeURIComponent(data.url) + '&title=' + encodeURIComponent(data.title) + '&summary=' + encodeURIComponent(data.text);
            default:
                return data.url;
        }
    }

    return function shareapi(data = {}, configuration = {}) {

        const useNative = typeof data.useNative !== 'undefined' ? data.useNative : true;
        const useNativeOnDesktop = typeof data.useNativeOnDesktop !== 'undefined' ? data.useNativeOnDesktop : useNative;
        const useNativeOnMobile = typeof data.useNativeOnMobile !== 'undefined' ? data.useNativeOnMobile : useNative;

        const forceOnDesktop = Boolean(useNativeOnDesktop && !isMobile);
        const forceOnMobile = Boolean(useNativeOnMobile && isMobile);

        const sharenative = ((forceOnDesktop || forceOnMobile ||
            (useNative && (forceOnDesktop || forceOnMobile)))
            && nativeShare
        );

        if (sharenative) {
            return nativeShare.call(navigator, data);
        }

        return new Promise((resolve, reject) => {
            //mandatory fields
            if (!data.url || !data.title || !data.text) {
                reject('Missing mandatory fields');
            }

            //merge configuration with default values
            const config = {
                ...{
                    copy: true,
                    print: true,
                    email: true,
                    facebook: true,
                    messenger: true,
                    twitter: true,
                    whatsapp: true,
                    telegram: true,
                    skype: false,
                    linkedin: true,
                },
                ...configuration
            };

            const closeAfterShare = typeof data.closeAfterShare !== 'undefined' ? data.closeAfterShare : true;
            
            // -- create elements
            const container = document.createElement('div');
            const backdrop = document.createElement('div');
            const confirm = document.createElement('div');

            container.className = 'share-container';
            backdrop.className = 'share-backdrop';
            confirm.className = 'share-confirm';
                
            let services = '';

            Object.keys(config).forEach(type => {
                if (config[type]) {
                    const item = buildItem(type, data);
                    services += item.outerHTML;
                }
            });
            
            container.innerHTML = `
                <div class="share-title"><span><i class="fas fa-external-link-alt"></i> Condividi</span> <span class="share-close"><i class="fas fa-times"></i></span></div>
                <div class="share-content">
                    ${services}
                </div>
            `;
            
            document.body.appendChild(container);
            document.body.appendChild(backdrop);
            document.body.appendChild(confirm);

            const containerOpacity = container.style.opacity;
            const backdropOpacity = backdrop.style.opacity;

            setTimeout(() => {
                container.classList.add('active');
                backdrop.classList.add('active');
            }, 100);

            //-- events
            backdrop.addEventListener('click', () => {
                
                container.classList.remove('active');
                backdrop.classList.remove('active');
                confirm.classList.remove('active');

                setTimeout(() => {
                    //we should remove all the listeners
                    document.removeEventListener('keydown', () => {});
                    window.addEventListener('afterprint', () => {});
                    backdrop.removeEventListener('click', () => {});

                    document.body.removeChild(container);
                    document.body.removeChild(backdrop);
                    document.body.removeChild(confirm);
                }, 1000);
            });

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    backdrop.click();
                }
            });

            window.addEventListener('afterprint', () => {
                showContainers();
            });

            container.querySelector('.share-close').addEventListener('click', () => {
                backdrop.click();
            });

            container.querySelectorAll('.share-item').forEach(item => {
                item.addEventListener('click', () => {
                    const type = item.dataset.type;
                    const url = item.dataset.url;

                    item.classList.add('active');
                    
                    switch (type) {
                        case 'copy':
                            navigator.clipboard.writeText(url);
                            break;
                        case 'print':
                            hideContainers();
                            setTimeout(() => {self.print()}, 500);
                            break;
                        default:
                            window.open(url, '_blank');
                        break;
                    }

                    resolve();
                    if (closeAfterShare) backdrop.click();
                });
            });

            function showContainers() {
                container.style.opacity = containerOpacity;
                backdrop.style.opacity = backdropOpacity;
            }

            function hideContainers() {
                container.style.opacity = 0;
                backdrop.style.opacity = 0;
            }

        });
    }
}());